// extracted by mini-css-extract-plugin
export var aTagButton = "Home-module--aTagButton--826b3";
export var aTagButtonSmall = "Home-module--aTagButtonSmall--d1e6d";
export var cardBlueTitle = "Home-module--cardBlueTitle--0ea27";
export var cardCents = "Home-module--cardCents--b0e84";
export var cardTitle = "Home-module--cardTitle--bd764";
export var heroImg = "Home-module--heroImg--d8a4e";
export var mailInputContainer = "Home-module--mailInputContainer--3f1e3";
export var signupButton = "Home-module--signupButton--ced23";
export var statNavLinkDark = "Home-module--statNavLinkDark--6f51c";
export var statNavLinkLight = "Home-module--statNavLinkLight--79cc2";